import { SortOrder, } from '../../Components/SelectionList/index.js';
import { COMMA } from './constants.js';
import {} from './types.js';
export const areOptionsEqual = (a, b) => a.value === b.value;
export const getOptionLabel = (option, formatOptionLabel) => formatOptionLabel?.(option) ?? option.label;
export const getOptionText = (option, formatOptionLabel, getOptionTextFn) => {
    if (getOptionTextFn) {
        return getOptionTextFn(option);
    }
    // If formatOptionLabel returns a string, use it; otherwise fall back to option.label
    const formatted = formatOptionLabel?.(option);
    return typeof formatted === 'string' ? formatted : option.label;
};
export const createOptionValueSet = (options) => new Set(options.map((option) => option.value));
export const filterOptionsExcluding = (options, excludeSet) => options.filter((option) => !excludeSet.has(option.value));
export const filterOptionsByString = (options, searchString, formatOptionLabel, getOptionTextFn) => {
    if (!options.length) {
        return [];
    }
    if (!searchString.trim()) {
        return options;
    }
    const searchTerms = searchString
        .toLowerCase()
        .split(COMMA)
        .map((term) => term.trim())
        .filter((term) => term.length > 0);
    return options.filter((option) => {
        const textContent = getOptionText(option, formatOptionLabel, getOptionTextFn).toLowerCase();
        return searchTerms.some((term) => textContent.includes(term));
    });
};
export const sortOptions = (options, order, formatOptionLabel, getOptionTextFn) => {
    if (!options?.length) {
        return [];
    }
    if (order === SortOrder.ASC) {
        return [...options].sort((a, b) => getOptionText(a, formatOptionLabel, getOptionTextFn).localeCompare(getOptionText(b, formatOptionLabel, getOptionTextFn)));
    }
    return [...options].sort((a, b) => getOptionText(b, formatOptionLabel, getOptionTextFn).localeCompare(getOptionText(a, formatOptionLabel, getOptionTextFn)));
};
